<template>
    <div class="card-grid">
      <b-row>
        <b-col>
          <li style="text-align: start" class="textoSubtitulo text-end">Métricas de hoy</li>
        </b-col>
        <b-col>
          <li  style="text-align: end" class="textoSubtitulo text-start" v-show="date"> {{ date }}</li>
        </b-col>
      </b-row>
      <div class="mt-2">
        <b-row no-gutters>
          <b-col class="ml-1" v-if="$localStorageService.can('Metricas_cita_agendada')">
            <div class="grid-item-1 pt-2">
              <div style="text-align: left;" class="ml-2">
                <p style="font-size: 30px;" class="texto-tratamiento">{{estadisticas.citasAgendadas}}</p>
              </div>
              <p class="texto-tratamiento">Citas agendadas</p>
            </div>
          </b-col>
          <b-col class="ml-3" v-if="$localStorageService.can('Metricas_sesion_concluida')">
            <div class="grid-item-2 pt-2">
              <div style="text-align: left;" class="ml-2">
                <p style="font-size: 30px;" class="texto-tratamiento">{{estadisticas.sesionesConcluidas}}</p>
              </div>
              <p class="texto-tratamiento">Sesiones concluidas</p>
            </div>
          </b-col>
          <b-col class="ml-3" v-if="$localStorageService.can('Metricas_pti_emitido')">
            <div class="grid-item-3 pt-2">
              <div style="text-align: left;" class="ml-2">
                <p style="font-size: 30px;" class="texto-tratamiento">{{estadisticas.citasSinConfirmar}}</p>
              </div>
              <p class="texto-tratamiento">Citas sin confirmar</p>
            </div>
          </b-col>
          <b-col class="ml-3" v-if="$localStorageService.can('Atajo_Agenda_clinica')">
            <div class="grid-item-4 pt-2">
              <div style="text-align: left;" class="ml-2">
                <p style="font-size: 30px;" class="texto-tratamiento">{{estadisticas.ptisEmitidos}}</p>
              </div>
              <p class="texto-tratamiento">PTI's emitidos</p>
            </div>
          </b-col>
        </b-row>
      </div>
      <p style="font-size: 12px;" class="mt-3 text-right">últ.actualización:{{estadisticas.fechaUltimaActualizacion | formatoFechaHoraTexto}}</p>
    </div>
</template>

<script>

export default {
  name: "estadisticaDashboard",
  components: {
  },data: () => ({
      date: '',
      ultimaActualizacion: null,
      estadisticas: {
        citasAgendadas: 0,
        citasSinConfirmar: 0,
        ptisEmitidos: 0,
        sesionesConcluidas: 0,
        fechaUltimaActualizacion: ''
      }
  }),methods: {
    obtenerEstadisticas() {
      const parametros = {
        idClinica: this.idClinica
      }
      this.$http.post(
          this.$api + 'dashboard/estadisticasDashboard', parametros).then(respuesta => {
        if (respuesta.data.data) {
          this.estadisticas = respuesta.data.data;
        }
      }).catch(error => {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Hubo un problema las estadisticas.",
        });
      })
    }
  },
  mounted: function () {
    this.date = this.$global.traerFechaLocal(this.$moment(this.$moment().format("YYYY-MM-DD")));
    this.obtenerEstadisticas()
  },
  computed: {
    idClinica() {
      return this.$localStorageService.getIdClinica() !== undefined &&
      this.$localStorageService.getIdClinica() !== null &&
      this.$localStorageService.getIdClinica() > 0
          ? this.$localStorageService.getIdClinica()
          : this.$clinicaIdDefecto;
    }
  }
}


</script>

<style scoped>
 .imagen-tratamiento {
    display: inline-block;
    margin-right: 5px;
  }
  
  .texto-tratamiento {
    text-align: center;
    color: #044169 !important;
    font-size: 12px;
  }

p{
  font-size: calc(0.55em + 1vmin);
}
@media only screen and (max-width: 600px) {
  p{
    font-size: 3vw;
  }
}
i{
  font-size: 1vw;
}

.card-grid{
  padding: 1% 3% 3% 3%;
  margin: 2% 6% 0% 3%;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0px 6px 17px -4px rgba(0, 0, 0, 0.12);
  height: 90%;
}



.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: .2fr .2fr;
  grid-gap: 10px; /* Espacio entre las celdas */
}

.grid-item-1{
  color: white;
  font-weight: bolder;
  border-radius: 5px;
  height: 120px;
  background-image: linear-gradient(to right, #FFE1FE, #FF94BF);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

.grid-item-2{
  color: white;
  border-radius: 5px;
  font-weight: bolder;
  height: 120px;
  background-image: linear-gradient(to right, #EFFCEF, #C2FFC2);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

}
.grid-item-3{
  color: white;
  font-weight: bolder;
  border-radius: 5px;
  height: 120px;
  background-image: linear-gradient(to right, #E6F5F9, #A0ECFF);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}
.grid-item-4{
  color: white;
  font-weight: bolder;
  border-radius: 5px;
  height: 120px;
  background-image: linear-gradient(to right, #FFE2B8, #FFC46E);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

i{
  float: left;
  width: 70%;
  height: 24px;
  align-items: center;
  font-size: 30px;
  display: inline-block;

}


img {
  filter: invert(100%);
}

</style>
